import type { Mapping } from '@pn/core/domain/data';
import { pnMappings } from '@pn/resources/pn-mappings';
import { stackMappings } from '@pn/resources/stack-mappings';
import { isNil } from 'lodash-es';

const mappingsCache = new Map<string, Mapping>(Object.entries(pnMappings));
const mergedMappingsCache = new Map<string, Mapping>();

let availableStackLayers: Record<string, boolean> = {};
export function setAvailableStackLayers(
  stackLayers: Record<string, boolean>
): void {
  availableStackLayers = stackLayers;
  mergedMappingsCache.clear();
}

export function setMapping(dataType: string, mapping: Mapping): void {
  mappingsCache.set(dataType, mapping);
  mergedMappingsCache.delete(dataType);
}

export function getMapping(dataType: string): Mapping | undefined {
  const mapping = mappingsCache.get(dataType);
  if (isNil(mapping)) return undefined;

  const cached = mergedMappingsCache.get(dataType);
  if (!isNil(cached)) return cached;

  const merged = { ...getStackMapping(dataType), ...mapping };
  mergedMappingsCache.set(dataType, merged);
  return merged;
}

function getStackMapping(dataType: string): Mapping {
  if (!isStackMappingAvailable(dataType)) return {};
  return stackMappings[dataType] ?? {};
}

function isStackMappingAvailable(dataType: string): boolean {
  return availableStackLayers[dataType] === true;
}
